<template>
  <div class="userWrap">
     <!-- <div class="accountMoney" v-if="integralList.length || cardDatalist.length" > -->
     <!-- <div class="accountMoney" v-if="integralList.length && userId == dawei || integralList.length && userId == wtao || integralList.length && userId == snan || integralList.length && userId == wheng || integralList.length && userId == scao || integralList.length && userId == tfang || integralList.length && userId == lxshui || integralList.length && userId == qhjiao || integralList.length && userId == lmeng || integralList.length && userId == dcun || integralList.length && userId == sales1 || integralList.length && userId == sales2 " >  -->
      <div @click="ToIntegral" v-if="merchantId == ''">
        <span>点击这里可以给积分账户充值~</span>
        <span></span>
      </div>
    <!-- </div> -->
    <p class="userId">ID:{{originalUserId}}</p>
    <div class="cardLoginList">
      <ul>
        <!-- 积分列表 -->
        <!-- <li v-for="item in integralList" :key="item.id"  @click="cardLogin(item)">
          <div class="list_card_left"><img src="@/assets/img/images/imgT.jpg" /></div>
          <div class="list_card_right">
            <h3 v-show="item.cardticketremaincount">余额:{{item.cardticketremaincount ? item.cardticketremaincount : ''}}</h3>
            <h3>{{item.cardname}}{{showcardtypename(item.cardtype)}}</h3>
            <p>点击使用</p>
          </div>
        </li> -->
        <!-- 卡包列表 -->
        <li v-for="item in cardDatalist" :key="item.id"  @click="cardLogin(item)">
          <div class="list_card_left" v-if="cityLogo != ''"><img :src="cityLogo"></div>
          <div class="list_card_left" v-else><img src="@/assets/img/images/imgT.jpg" /></div>
          <div class="list_card_right">
            <h3>{{item.cardname}}{{showcardtypename(item.cardtype)}}</h3>
            <p>点击使用</p>
          </div>
        </li>
      </ul>
      <div class="center_box_list" v-if="cardDatalist.length == 0 && integralList.length == 0">
        {{errorMsg}}
      </div>
      <div class="bottomheight"></div>
    </div>
    <div class="bottom">
      <div class="item2" @click="my">
        <p>我的</p>
      </div>
      <!-- <div class="item2" @click="noCardLogin">
        <p>无卡登陆</p>
      </div> -->
      <!-- <div class="item2" @click="myOrder" v-else>
        <p>我的订单</p>
      </div> -->
      <div class="item1" @click="cardBind">
        <p>绑定新卡</p>
      </div>
    </div>
    <Bounced type='confirm' @took='queRenOk' @tocancel='() => showDio = false' :showstate='showDio' >
      <span slot='tlt'>提示</span>  <div slot='text'>您的积分不足，是否前往充值 ?</div>
    </Bounced>
  </div>
</template>
<script>
import * as api from '@/api'
import JmmToast from '@/components/JmmToast'
import wx from 'weixin-js-sdk'
import Bounced from "@/components/Bounced";
export default {
  name: 'userWrap',
  data() {
    return {
      showDio: false,     // 模态框
      openId: '',     
      userId: '',  
      originalUserId:'',   
      isRecharge: '',     // 判断是不是充值成功的状态
      
      // 小程序测试-白名单
      dawei: 'cfbklfkgmjfpcnllgfmjdeicjmifkjhhhpagghfkkafelpamjmiigdhkknhfgegn',
      wtao: 'jmindmipdhiiclloneblpapjnchofjegjinpaekaoepkalibglfopkeopfgeajfi',
      snan: 'bhihhpopfeiiphfgmjjejgemogkceadkamkpkmjgkgbdeegfmefcjiiaghkjghil',
      wheng: 'oiecafblacikokkpkoeemplkcceepolpcbgegfhchipooafhdahoelggdbbgggjg',
      scao: 'fhkhgfljjhndihpcbkkbblgbjigheoolflnlokcodccilkiodncldifchelmlmml',
      tfang: 'bliflggikdmombpnlpigladcokhnjpdgfacjgopbelfmhdmdceodgdfkgfhnpogp',
      lxshui: 'lohedgnfkhabfoobeihhkcgmgcnnlfeipkidondfnongbbffpfmhemhhohajdefd',
      qhjiao: 'geplefmlgkbjodcjmkgggklmigdnmopnkmalclcbocgokkdoiidbnbejbajgmnbm',
      lmeng: 'hkalkcamdkhpmcjfjgaipacjoaohjgaccbgegfhchipooafhdahoelggdbbgggjg',
      dcun: 'ndbnijcfnclnfppppjpnnjedbppceblhjinpaekaoepkalibglfopkeopfgeajfi',
      sales1: 'dcllnogadmgfoickmplmckcemnbdbnaeflnlokcodccilkiodncldifchelmlmml',
      sales2: 'jhjfogmadeonimkgmjlpbflepklpkbkmdlndoonfgbdcplakckplnbojmoekaebj',
       
      token: '',
      sign: '',
      integralList: [],      // 积分卡数组
      cardDatalist: [],      // 非积分卡数组
      channel: '',           // 判断渠道ID
      cardRights: '50000',   // 电影权限
      channelSource: '',     //渠道来源
      channelPlatform: '',   //渠道平台
      errorMsg: '没找到卡，请您点击下方绑卡哦~ ',         //错误信息
      merchantId: "",      //城市账户编码
      cityLogo: "",   // 城市logo
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    if(null == this.merchantId){
      this.merchantId = '';
    }
    if(undefined == this.merchantId){
      this.merchantId = '';
    }
    this.cityLogo = localStorage.getItem("cityLogo");
    this.token = this.$route.query.token
    this.sign = this.$route.query.sign
    this.openId = this.$route.query.openId 
    this.userId = this.$route.query.sign
    this.isRecharge = this.$route.query.isRecharge
    this.channel = this.$route.query.channel
    this.channelSource = this.$route.query.source
    this.channelPlatform = this.$route.query.platform
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
    if(null == this.channelSource || undefined == this.channelSource){
      this.channelSource = '';
    }
    if(null == this.channelPlatform || undefined == this.channelPlatform){
      this.channelPlatform = '';
    }
    if("BAIHUO" == this.channel){
      this.cardRights = "10000,10020";
    }
  },
  components: { JmmToast, Bounced },
  mounted() {
    this.findList();
    this.getwebAppId();
  },
  methods: {
    queRenOk() {
        this.ToIntegral()
     },
     // 获取城市appId
    async getwebAppId(){
      try {
        let info = {}
        const res = await api.user.getwebAppId(info)
        if (res.code == "000000") {
          this.cityLogo = res.data.logo;
          if(this.cityLogo == null || this.cityLogo == undefined){
            this.cityLogo = "";
          }
          localStorage.setItem('cityLogo', this.cityLogo);  
        }
      } catch (err) {
        console.log(err)
      }      
    },
    // 4.1 跳转积分页面
    async ToIntegral(){
      const res = await api.user.getIntegralsign()
      if (res.code == '000000') {
        let toJfen = `/pages/index/index?isRecharge=1&recharge=`
        let dataJson = { 
          goodsType: 50000, 
          backUrl: toJfen,
          number: 1,
          notifyUrl: `https://accountapi.kangou.cn/api/code/huidiaoPost`,
          // notifyUrl: 'https://test2.gonghuidefu.com/api/code/huidiaoPost', // https://accountapi.kangou.cn/api/code/huidiao
          source: 3,
          isRecharge: 1,
          openId: this.openId
        }  
        let inteUrl = `https://pay.kangou.cn/paycenter/api/card/toRechargePage/?businessId=${res.data.businessId}&userId=${this.userId}&time=${res.data.time}&sign=${res.data.sign}&channel=${this.channel}&data=${encodeURIComponent(JSON.stringify(dataJson))}`
        window.location.href = inteUrl
      }
    },  
    showcardtypename: function (cardtype) {
      //if(cardtype==9999){
      //  return "";
      //}else{
      //  return "包";
      //}
    },
    // 3 获取列表
    async findList () {
      try {
        let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj'
        let testSign = 'dpbijiiiefibmadgopamipinnnpnphof'
        localStorage.setItem('reToken', this.token == undefined ? testToken : this.token)
        // let params = {
        //   "cardType": "17", 
        //   "cardRights": "4001", 
        //   "sign": this.sign ? this.sign : testSign,
        //   "getIntegral" : this.isRecharge == 1 ? "1" : ''
        // }
        // const integralResult = await api.user.getIntgerCard(params);
        // //积分列表
        // this.integralList = integralResult.data;
        //this.integralList = [];
        if(null == this.integralList){
          this.integralList = [];
        }

        let info = {
          "cardRights": this.cardRights, 
          "sign": this.sign ? this.sign : testSign, 
          "userid": 0,
          channel: this.channel,
        }
        const cardDataResult = await api.user.cardList(info);

        let errorMsg = cardDataResult.errorMsg;
        if(null != errorMsg && undefined != errorMsg && '' != errorMsg){
          this.errorMsg = errorMsg;
        }

        //卡包列表
        this.cardDatalist = cardDataResult.data;
        
        if('' == this.originalUserId && null != this.cardDatalist && this.cardDatalist.length > 0){
          this.originalUserId = this.cardDatalist[0].userId;
          if(null == this.originalUserId || undefined == this.originalUserId){
            this.originalUserId = '';
          }
        }
        if('' == this.originalUserId && null != this.integralList && this.integralList.length > 0){
          this.originalUserId = this.integralList[0].userId;
          if(null == this.originalUserId || undefined == this.originalUserId){
            this.originalUserId = '';
          }
        }
        //如果用户编码为空,查询用户接口
        if('' == this.originalUserId){
          let data = {
            sign: this.sign
          }
          const findByIdResult = await api.user.findById(data);
          if (findByIdResult.code == '000000') {
            this.originalUserId = findByIdResult.data.id;
          }
        }
        let integralBool =  true;//this.userId == this.dawei || this.userId == this.wtao || this.userId == this.snan || this.userId == this.wheng || this.userId == this.scao || this.userId == this.tfang || this.userId == this.lxshui || this.userId == this.qhjiao || this.userId == this.lmeng || this.userId == this.dcun || this.userId == this.sales1 || this.userId == this.sales2
        if(!integralBool){
          this.integralList = [];
        }
      } catch (error) {
        JmmToast(error)
      }
    },
    my() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //微信环境 JmmToast("微信环境"+1.5)
        wx.miniProgram.getEnv(function (res) {
          //JmmToast("微信环境"+2)
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: "/pages/personalCenterTwo/personalCenterTwo",
            });
          }
        })
      } else {
        //非小程序环境下逻辑
        JmmToast('只支持小程序访问')
        return false
      }
    },
    myOrder() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //微信环境 JmmToast("微信环境"+1.5)
        wx.miniProgram.getEnv(function (res) {
          //JmmToast("微信环境"+2)
          if (res.miniprogram) {
            wx.miniProgram.navigateTo({
              url: '/pages/orderAll/orderAll?status=0'
            })
          }
        })
      } else {
        //非小程序环境下逻辑
        JmmToast('只支持小程序访问')
        return false
      }
    },
    noCardLogin() {
      var that = this
      let info = {
        cardName: '',
        controlCommon: '',
        controlMovie: '',
        cardType: '',
        openCardCity: '',
        cardNumber: '',
        cardRights: '',
        cardkindprice: '',
        source: '',
        citySource: '',
        cardlevel: '',
      }
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //JmmToast("微信环境"+1.5)
        //微信环境
        wx.miniProgram.getEnv(function (res) {
          //JmmToast("微信环境"+2)
          if (res.miniprogram) {
            wx.miniProgram.reLaunch({
              url: '/pages/filmList/filmList?channelSource=' + that.channelSource + '&channelPlatform=' + that.channelPlatform + '&info=' + JSON.stringify(info),
            })
          }
        })
      } else {
        //非小程序环境下逻辑
        JmmToast('只支持小程序访问')
        return false
      }
    },
    cardLogin: function (item) {
      var that = this
      if (item.cardticketremaincount) {
        if (Math.ceil(item.cardticketremaincount) <= 0) {
          this.showDio = true;
          return;
        }
      }
      let info = {
        cardName: item == undefined ? '' : item.cardname,
        controlCommon: item == undefined ? '' : item.controlcommon,
        controlMovie: item == undefined ? '' : item.controlmovie,
        cardType: item == undefined ? '' : item.cardtype,
        openCardCity: item == undefined ? '' : item.openCardCity,
        cardNumber: item == undefined ? '' : item.cardnumber,
        cardRights: item == undefined ? '' : item.cardrights,
        cardkindprice: item == undefined ? '' : item.cardkindprice,
        source: item == undefined ? "" : item.source,
        citySource: item == undefined ? "" : item.citySource,
        cardlevel: item == undefined ? "" : item.cardlevel,
      }
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //JmmToast("微信环境"+1.5)
        //微信环境
        wx.miniProgram.getEnv(function (res) {
          //JmmToast("微信环境"+2)
          if (res.miniprogram) {
            wx.miniProgram.reLaunch({
              url: '/pages/filmList/filmList?channelSource=' + that.channelSource + '&channelPlatform=' + that.channelPlatform + '&info=' + JSON.stringify(info),
            })
          }
        })
      } else {
        //非小程序环境下逻辑
        JmmToast('只支持小程序访问')
        return false
      }
    },
    cardBind: function () {
      let _this = this
      let testToken = _this.token == undefined ? 'lmojakdhkadocfaccfjocklccdfkhgoj' : _this.token
      let testSign = _this.sign == undefined ? 'dpbijiiiefibmadgopamipinnnpnphof' : _this.sign
      let toUrl = `cardbind.html#/?merchantId=${this.merchantId}&channel=${this.channel}&sign=${testSign}&token=${testToken}&openId=${this.openId}`
       window.location.href = toUrl
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'
@import '../../assets/css/stylesheet.css'
.userWrap
  width 100%
  height 100%
  overflow auto
  background #f5f5f5
.cardLoginList ul {
  width: calc(100% - 40px);
   margin: 0 auto;
   color: #fff;
     li {
      width: 100%
      height 205px
      background: url('../../assets/img/images/bgCard.png') no-repeat center;
      background-size: cover;
      margin: 20px auto;
      border-radius: 15px;
      display flex
      align-items center
      .list_card_left,  .list_card_right {
         padding-left: 35px;
      }
     .list_card_right {
        h3 {
          font-size 33px
        }
        p {
          font-size 28px
        }
      }
      .list_card_left img {
        width: 100px;
        height: 100px;
      }
   }
}
.bottom
  position fixed
  bottom 0px
  background-color #fff
  width 100%
  height 80px
  text-align center
.item1
  width 50%
  background #ff1734
  float left
.item1 p
  margin 0
  font-size 28px
  color #fff
  line-height 80px
.item2
  width 50%
  background #999999
  float left
.item2 p
  margin 0
  font-size 28px
  color #fff
  line-height 80px
.bottomheight
  height 100px

.accountMoney {
  width: 99%;
  line-height: 50px;
  padding: 15px 0;
  border: 1px solid #ddd;
  margin:0 auto;
  margin-top: 12px;
  background-color #fff
  div {
    width: 93%;
    margin: 0 auto;
    display flex
    justify-content space-between
    align-items center
    font-size 28px
    span:first-child {
      display block
    }
    span:last-child {
      display block
      width: .25rem;
      height: .25rem;
      border-top: 0.04rem solid #000;
      border-right: 0.04rem solid #000;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }
}
.userId{
  font-size: 28px;
  padding: 0 24px;
  margin-top: 20px;
}
.center_box_list {
  font-size: 28px;
  font-family: Source Han Sans SC VF;
  text-align: center;
	border-radius: 20px;
	width: 80%;
	height: 350px;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/cardlogin/index.vue